import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  Grid,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Card,
  CardContent,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import Refresh from '@mui/icons-material/Refresh';

const TDSReport = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchData, setSearchData] = useState({
    panNo: '',
    payout: '',
    financialYear: '',
    financialMonth: ''
  });

  // Sample data for TDS Report
  const [tdsData] = useState([
    {
      id: 1,
      associateId: 'ASC001',
      associateName: 'Rajesh Kumar',
      panNo: 'ABCDE1234F',
      grossAmount: 50000,
      tds: 5000,
      netAmount: 45000,
    },
    {
      id: 2,
      associateId: 'ASC002',
      associateName: 'Priya Sharma',
      panNo: 'FGHIJ5678K',
      grossAmount: 75000,
      tds: 7500,
      netAmount: 67500,
    },
    {
      id: 3,
      associateId: 'ASC003',
      associateName: 'Amit Patel',
      panNo: 'KLMNO9012P',
      grossAmount: 60000,
      tds: 6000,
      netAmount: 54000,
    },
    {
      id: 4,
      associateId: 'ASC004',
      associateName: 'Sunita Verma',
      panNo: 'QRSTU3456V',
      grossAmount: 80000,
      tds: 8000,
      netAmount: 72000,
    },
    {
      id: 5,
      associateId: 'ASC005',
      associateName: 'Vikash Singh',
      panNo: 'WXYZB7890A',
      grossAmount: 45000,
      tds: 4500,
      netAmount: 40500,
    },
    {
      id: 6,
      associateId: 'ASC006',
      associateName: 'Deepika Rao',
      panNo: 'CDEFG1234H',
      grossAmount: 65000,
      tds: 6500,
      netAmount: 58500,
    },
  ]);

  const payoutOptions = ['PO001', 'PO002', 'PO003', 'PO004', 'PO005'];
  const financialYears = ['2023-24', '2024-25', '2025-26'];
  const financialMonths = [
    'April', 'May', 'June', 'July', 'August', 'September',
    'October', 'November', 'December', 'January', 'February', 'March'
  ];

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const handleInputChange = (field, value) => {
    setSearchData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSearch = () => {
    console.log('Searching with data:', searchData);
    // Implement search functionality
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
    }).format(amount);
  };

  return (
    <Box sx={{ p: 3, backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2}>
          <Box>
            <Typography variant="h4" sx={{ fontWeight: 700, color: '#536DFE', mb: 0.5 }}>
              TDS Report
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Manage and view all TDS reports
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Main Content Card */}
      <Card sx={{ boxShadow: '0 2px 12px rgba(0,0,0,0.1)', borderRadius: 2, mb: 3 }}>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
            TDS Reports
          </Typography>
        
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              label="PAN No"
              value={searchData.panNo}
              onChange={(e) => handleInputChange('panNo', e.target.value)}
              size="small"
              placeholder="Enter PAN Number"
            />
          </Grid>
          
          <Grid item xs={12} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel>Payout</InputLabel>
              <Select
                value={searchData.payout}
                label="Payout"
                onChange={(e) => handleInputChange('payout', e.target.value)}
              >
                <MenuItem value="">
                  <em>Select Payout</em>
                </MenuItem>
                {payoutOptions.map((payout) => (
                  <MenuItem key={payout} value={payout}>
                    {payout}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Financial Year</InputLabel>
              <Select
                value={searchData.financialYear}
                label="Financial Year"
                onChange={(e) => handleInputChange('financialYear', e.target.value)}
              >
                <MenuItem value="">
                  <em>Select Year</em>
                </MenuItem>
                {financialYears.map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Financial Month</InputLabel>
              <Select
                value={searchData.financialMonth}
                label="Financial Month"
                onChange={(e) => handleInputChange('financialMonth', e.target.value)}
              >
                <MenuItem value="">
                  <em>Select Month</em>
                </MenuItem>
                {financialMonths.map((month) => (
                  <MenuItem key={month} value={month}>
                    {month}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} md={2}>
            <Box display="flex" gap={2}>
              <Button
                variant="contained"
                startIcon={<SearchIcon />}
                onClick={handleSearch}
                sx={{ 
                  textTransform: 'none',
                  fontWeight: 600
                }}
              >
                Search
              </Button>
              
             
            </Box>
          </Grid>
        </Grid>

        {/* TDS Report Table */}

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#536DFE' }}>
                <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: '14px' }}>S.No</TableCell>
                <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: '14px' }}>Associate ID</TableCell>
                <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: '14px' }}>Associate Name</TableCell>
                <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: '14px' }}>PAN No</TableCell>
                <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: '14px' }}>Gross Amount</TableCell>
                <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: '14px' }}>TDS</TableCell>
                <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: '14px' }}>Net Amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tdsData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow 
                    key={row.id}
                    sx={{
                      '&:nth-of-type(odd)': { backgroundColor: '#f9f9f9' },
                      '&:hover': { backgroundColor: '#f0f7ff !important' }
                    }}
                  >
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                    <TableCell>{row.associateId}</TableCell>
                    <TableCell>{row.associateName}</TableCell>
                    <TableCell sx={{ fontFamily: 'monospace' }}>{row.panNo}</TableCell>
                    <TableCell>{formatCurrency(row.grossAmount)}</TableCell>
                    <TableCell sx={{ color: '#d32f2f' }}>{formatCurrency(row.tds)}</TableCell>
                    <TableCell sx={{ color: '#2e7d32' }}>{formatCurrency(row.netAmount)}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={tdsData.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          
          sx={{ mt: 2 }}
        />
        </CardContent>
      </Card>
    </Box>
  );
};

export default TDSReport;